import gsap from 'gsap'

//UTILITY FUNCTIONS
function $ (className){
  return document.querySelector(`.${className}`)
}
function $$ (id){
  return document.querySelector(`#${id}`)
}

// blend two hex colors together by an amount
// https://stackoverflow.com/questions/6367010/average-2-hex-colors-together-in-javascript/56348573#56348573
function blendColors(colorA, colorB, amount) {
  const [rA, gA, bA] = colorA.match(/\w\w/g).map((c) => parseInt(c, 16));
  const [rB, gB, bB] = colorB.match(/\w\w/g).map((c) => parseInt(c, 16));
  const r = Math.round(rA + (rB - rA) * amount).toString(16).padStart(2, '0');
  const g = Math.round(gA + (gB - gA) * amount).toString(16).padStart(2, '0');
  const b = Math.round(bA + (bB - bA) * amount).toString(16).padStart(2, '0');
  return '#' + r + g + b;
}

// SELECTIONS
const tank = $('tank')
const waveFillRect = $('wave-fill')
const wavePattern = $$('wave-pattern')

const info = $('info')

const spiralR = $('spiral-R')
const spiralL = $('spiral-L')
const flowR = $('flow-R')
const flowL = $('flow-L')
const arrowR = $('arrow-R')
const arrowL = $('arrow-L')

//Pipes
const jetMixer = $('jet-mixer')
const pipeOutletInner = $('pipe-outlet-inner')
const pipeOutletOuter = $('pipe-outlet-outer')
const pipeInletInner = $('pipe-inlet-inner')
const pipeInletOuter = $('pipe-inlet-outer')

//Valves
const outFlowGateValve = $('gate-valve');
const inFlowGateValve = $('gate-valve_2');
const inFlowNRCValve = $('NRC-valve-BL');

//Flows
const outFlow = $('out-flow')
const inFlow = $('in-flow')

//Arrows
const downOutlet = $('downOutlet')
const rightOutlet = $('rightOutlet')
const upInlet = $('upInlet')
const leftInlet = $('leftInlet')

//Fan
const fan = $('fan')

//Fan Wings
// const innerFanWings = $('inner-fan-wings')
const outerFanWings = $('outer-fan-wings-g')

//Tank
const linearGradient = $$('paint0_linear')
const waveGradient = $$('paint1_linear')

//Colors:
// https://stackoverflow.com/questions/9275695/read-attributes-of-svg-elements-in-html-via-js
const topColor = linearGradient.firstChild.getAttributeNode('stop-color').nodeValue
const bottomColor = linearGradient.lastChild.getAttributeNode('stop-color').nodeValue
const blendedColor = blendColors(topColor, bottomColor, 0.5)

// ANIMATION UTILITY FUNCTIONS
function drawSVG(path, drawingDuration = 2, ease = 'power4.out', positionParameter = '') {
  const l = path.getTotalLength()
  const tl = new gsap.timeline()
  tl.set(path, {strokeDasharray:l})
    .fromTo(path, {
      strokeDashoffset:l,
      opacity: 0
    }, {
      strokeDashoffset:0,
      duration: drawingDuration,
      opacity: 1,
      ease: ease
    }, positionParameter);
  return tl
}

function curvedDrawingSVGAndStrokeAnimation(path, duration = 10, strokeDasharray= '4 4', reverse = false){
  const tl = new gsap.timeline()
  drawSVG(path, reverse)

  if(!reverse){
    tl.to(path, {
      strokeDasharray: strokeDasharray,
      strokeOpacity: 0.5,
      ease: 'power4.out',
      duration: 0.2
    }, 'dashes+=1')
  
    .fromTo(path, {
      strokeDashoffset: path.getTotalLength() , 
    }, {
      strokeDashoffset: 0,
      ease: 'linear',
      repeat: -1,
      duration: duration
    }, '>')  

  } else {
    tl.to(path, {
      strokeDasharray: strokeDasharray,
      strokeOpacity: 0.5,
      ease: 'power4.out',
      duration: 0.2
    }, 'dashes+=1')
  
    .fromTo(path, {
      strokeDashoffset: 0,
    }, {
      strokeDashoffset: path.getTotalLength() , 
      ease: 'linear',
      repeat: -1,
      duration: duration
    }, '>')  
  }
  
  return tl
}

function makeThemAppear(element, drawingDuration = 2, ease = 'sine', positionParameter = ''){
  const tl = new gsap.timeline()
  tl
    .fromTo(element, {
      opacity: 0
    }, {
      duration: drawingDuration,
      opacity: 1,
      ease: ease
    }, positionParameter);
  return tl
}
//ANIMATIONS
function setThings(){
  const tl = new gsap.timeline()
  tl.set([pipeOutletInner, pipeOutletOuter, pipeInletInner, pipeInletOuter, jetMixer], {
    opacity: 0,
  })
  .set([outFlowGateValve, inFlowGateValve, inFlowNRCValve], {
    opacity: 0
  })
  .set([spiralR, spiralL, flowL, flowR, arrowL, arrowR], {
    opacity: 0,
  })
  .set([inFlow, outFlow], {
    opacity: 0,
  })
  .set([upInlet, downOutlet, leftInlet, rightOutlet], {
    opacity: 0
  })
  .set(info, {
    opacity: 0,
  })
  return tl
}
// function waterWaving(){
//   const tl = new gsap.timeline()
//   tl.fromTo(wavePattern, {
//     x: -1900
//   }, {
//     x: 0,
//     duration: 10,
//     repeat: -1
//   })
//   return tl
// }


function entryofTankAndFan() {
  const tl = new gsap.timeline
  tl.from(tank, {
      opacity: 0,
      y: -5,
      ease: 'sine',
      duration: 1
  }).from(fan, {
      opacity: 0,
      x: 5,
      ease:  'sine',
      duration: 1
  }, "")
  return tl
}

function pipeCreations(){
  const tl = new gsap.timeline()
  drawSVG(pipeOutletInner)
  drawSVG(pipeOutletOuter)
  drawSVG(pipeInletInner)
  drawSVG(pipeInletOuter)
  .to(jetMixer, {
    opacity: 1,
    duration: 0.5,
    ease: 'expo.in'
  }, '-=0.5')
  return tl
}

function makingPipesValvesAppear(){
  const tl = new gsap.timeline()
  makeThemAppear(pipeOutletInner)
  makeThemAppear(pipeOutletOuter)
  makeThemAppear(pipeInletInner)
  makeThemAppear(pipeInletOuter)
  makeThemAppear(outFlowGateValve)
  makeThemAppear(inFlowGateValve)
  makeThemAppear(inFlowNRCValve)
  .to(jetMixer, {
    opacity: 1,
    duration: 0.5,
    ease: 'sine'
  }, '-=0.5')
  return tl
}

function outletFlowStart(){
  const tl = new gsap.timeline()
  tl
  .fromTo(outerFanWings, {
    rotate: '360deg',
    transformOrigin: 'center center',
  }, {
    rotate: '0deg',
    repeat: -1,
    duration: 2.5,
    opacity: 1,
    ease: 'linear'
  })
  // .fromTo(innerFanWings, {
  //     rotate: '0deg',
  //     transformOrigin: 'center center',
  //   }, {
  //     rotate: '360deg',
  //     repeat: -1,
  //     duration: 1.5,
  //     opacity: 1,
  //     ease: 'linear'
  //   })

    .fromTo(downOutlet, {
        y: -10,
        opacity: 0,
        ease: 'expo.out',
        duration: 0.2
      }, {
        y: 0,
        opacity: 1,
    }, '-=1')

    .fromTo(outFlow, {
      strokeDasharray: "0 0",
      opacity: 0,
      duration: 0.5,
      attr: {d:  "M61.6 265.836"}
    }, {
      opacity: 1,
      attr: {d:  "M61.6 265.836v78.191"}
    })

    .fromTo(rightOutlet, {
      x: -10,
      opacity: 0,
      ease: 'expo.in',
      duration: 0.2
    }, {
      x: 0,
      opacity: 1
    }, '-=0.5')

    // .fromTo(outFlowGateValve, {opacity: 0, x: 10, duration: 0.2, ease: 'expo.in'}, {x: 0, opacity: 1}, '-=0.2')

    .to(outFlow, {
      attr: {d: "M61.6 265.836v78.191h307.772"},
      strokeDasharray: '6.38 6.38',
    })

    .fromTo(outFlow, {
      strokeDashoffset: outFlow.getTotalLength() , 
    }, {
      strokeDashoffset: 0,
      ease: 'linear',
      repeat: -1,
      duration: 4
    })

  return tl
}

function inletFlowStart(){
  const tl = new gsap.timeline()

  tl
  // .fromTo(outerFanWings, {
  //   rotate: '360deg',
  //   transformOrigin: 'center center',
  // }, {
  //   rotate: '0deg',
  //   repeat: -1,
  //   duration: 2.5,
  //   opacity: 1,
  //   ease: 'linear'
  // })

  .addLabel('arrows')
  .fromTo(upInlet, {
      y: 10,
      opacity: 0,
      ease: 'expo.out',
      duration: 0.2
    }, {
      y: 0,
      opacity: 1,
  }, '')

  .addLabel('flow')
  .fromTo(inFlow, {
    strokeDasharray: "0 0",
    opacity: 0,
    duration: 0.5,
    attr: {d:  "M399.317,339.036"}
  }, {
    opacity: 1,
    attr: {d:  "M399.317,339.036v-124.773"}
  }, '>')

  .fromTo(leftInlet, {
    x: 15,
    opacity: 0,
    ease: 'expo.in',
    duration: 0.2
  }, {
    x: -4,
    opacity: 1
  }, 'arrows+=0.5')

  // .fromTo([inFlowGateValve, inFlowNRCValve], {
  //   opacity: 0, x: -10, duration: 0.2, ease: 'expo.in'
  // }, {x: 0, opacity: 1,  stagger:0.2}, 'arrows-=1.5')

  .to(inFlow, {
    duration: 0.5,
    attr: {d: 'M399.317,339.036v-124.773h-139.745'}
  }, 'flow+=0.5')

  .to(inFlow, {
    duration: 0.4,
    attr: {d: "M399.317,339.036v-124.773h-139.745l-18.3,-6.654"},
    strokeDasharray: '6.38 6.38',
  }, 'flow+0.2')

  // For Stroke animation
  .fromTo(inFlow, {
    strokeDashoffset: inFlow.getTotalLength() , 
  }, {
    strokeDashoffset: 0,
    ease: 'linear',
    repeat: -1,
    duration: 4
  })

  return tl
}

function tankFlowLines(){
  const tl = new gsap.timeline()
  //Draw the two lines
  drawSVG(flowR, 3)
  drawSVG(flowL, 3)

  tl
  
  .to([spiralL, spiralR], {opacity: 1})
  drawSVG(spiralL, 2, 'sine.in', '0.5')
  drawSVG(spiralR, 2, 'sine.in', '0.5')
  .to([arrowR, arrowL], {
    opacity: 1,
  })
  .addLabel('dashes')
  .to([spiralL, spiralR], {
    strokeDasharray: '4 6',
    ease: 'power4.out',
    strokeOpacity: 0.5,
    duration: 0.1
  }, '>')
  .fromTo([spiralL, spiralR], {
    strokeDashoffset: spiralL.getTotalLength() , 
  }, {
    strokeDashoffset: 0,
    ease: 'linear',
    repeat: -1,
    duration: 30
  }, '>')

  .to(flowL, {
    strokeDasharray: '4 4',
    strokeOpacity: 0.5,
    ease: 'power4.out',
    duration: 0.2
  }, 'dashes')

  .fromTo(flowL, {
    strokeDashoffset: flowL.getTotalLength() , 
  }, {
    strokeDashoffset: 0,
    ease: 'linear',
    repeat: -1,
    duration: 10
  }, '>')

  .to(flowR, {
    strokeDasharray: '4 4',
    ease: 'power4.out',
    strokeOpacity: 0.5,
    duration: 0.2
  }, 'dashes')
  .fromTo(flowR, {
    strokeDashoffset: flowR.getTotalLength() , 
  }, {
    strokeDashoffset: 0,
    ease: 'linear',
    repeat: -1,
    duration: 10
  }, '>')
  return tl
}

function infoAnimation(){
  const tl = new gsap.timeline()
  .fromTo(info, {
    opacity: 0,
    ease: 'easeOut',
    y: -20,
    duration: 5
  }, {
    opacity: 1,
    y: 0
  })
  return tl
}

function tankColors (){
  const tl = new gsap.timeline()

  tl.addLabel('changeGradients')
  .to(linearGradient, {
    attr: {y2: 287},
    duration: 4,
    ease: 'linear'
  }, 'changeGradients')
  // .to(wavePattern, {
  //   attr: {d: 'M274 145H0v142h274V145z'},
  //   duration: 4
  // }, '')

  .to(waveGradient, {
    attr: {y1:-143, y2:143},
    duration: 4,
  }, 'changeGradients')

  //Diaappearing the bottom rect
  .to(waveFillRect, {
    opacity: 0,
    autoAlpha: 0,
    ease: 'linear',
    duration: 4
  })

  .addLabel('changeToPurple')
  .to(linearGradient.children, {
    stopColor: blendedColor,
    duration: 4,
  }, 'changeToPurple')
  .to([inFlow, outFlow], {
    stroke: blendedColor,
    duration: 4
  }, 'changeToPurple')

  return tl
}

const master = new gsap.timeline()
master.add(setThings)
      .add(entryofTankAndFan)
      .add(makingPipesValvesAppear, '')
      // .add(pipeCreations, "+=2")
      .add(outletFlowStart, '+=2.5')
      .add(inletFlowStart, "+=3.5")
      .add(tankFlowLines, "+=2")
      .add(tankColors, "+=3")
      .add(infoAnimation, '-=3')